import React, { useState, useEffect, useContext } from 'react'
import { FormattedMessage } from 'react-intl'

import { FiltersContext } from 'client/components/FiltersContainer/context'
import Checkbox from 'src/comps/Checkbox'

import { FilterRatingsBase, Title, List } from './styles'
import globalMessages from 'client/messages'
import messages from './messages'

const availableRatings = ['9', '8', '7', '6']

const FilterRatings = () => {
  const { filters, setFilters } = useContext(FiltersContext)
  const [selected, setSelected] = useState([])

  useEffect(() => {
    setSelected(filters.ratings || [])
  }, [filters.ratings])

  function handleClick(rating) {
    const index = selected.indexOf(rating)
    const ratingExists = index > -1
    const filteredRatings = ratingExists
      ? selected.filter((f, i) => i !== index)
      : [...selected, rating]

    setFilters({ ...filters, ratings: filteredRatings })
  }

  return (
    <FilterRatingsBase>
      <Title>
        <FormattedMessage {...globalMessages.guestRating} />
      </Title>

      <List>
        {availableRatings.map(rating => {
          const isSelected = !!selected.find(r => r === rating)

          return (
            <li key={`rating-${rating}`}>
              <Checkbox
                label={
                  <>
                    <FormattedMessage {...messages[`rating${rating}`]} />
                    {`: ${rating}+`}
                  </>
                }
                name={`rating-${rating}`}
                onChange={() => handleClick(rating)}
                selected={isSelected}
              />
            </li>
          )
        })}
      </List>
    </FilterRatingsBase>
  )
}

export default FilterRatings
